import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  og_title: string;
  og_description: string;
  og_image: string;
}

const defaultSEO: SEOData = {
  title: "PTA Hub - Modern PTA Management Platform",
  description: "Empower your school PTA with modern tools for member management, events, fundraising, and more. The all-in-one platform for PTAs.",
  keywords: "PTA, parent teacher association, school management, fundraising, events, member management",
  og_title: "PTA Hub - Modern PTA Management Platform",
  og_description: "Empower your school PTA with modern tools for member management, events, fundraising, and more.",
  og_image: "https://ptahub.co.uk/logo-full.png",
};

export function useSEO(slug: string) {
  const [seoData, setSeoData] = useState<SEOData>(defaultSEO);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const { data, error } = await supabase
          .from("seo_metadata")
          .select("*")
          .eq("page_slug", slug)
          .maybeSingle();

        if (error) {
          console.error("Error fetching SEO data:", error);
          setLoading(false);
          return;
        }

        if (data) {
          setSeoData({
            title: data.title || defaultSEO.title,
            description: data.meta_description || defaultSEO.description,
            keywords: data.meta_keywords || defaultSEO.keywords,
            og_title: data.og_title || data.title || defaultSEO.og_title,
            og_description: data.og_description || data.meta_description || defaultSEO.og_description,
            og_image: data.og_image || defaultSEO.og_image,
          });
        }
      } catch (err) {
        console.error("Error in useSEO:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSEO();
  }, [slug]);

  return { seoData, loading };
}
